import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import ScrollToTopButton from "@/components/site/ScrollToTop";

export default function Layout({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="App font-body text-ink min-h-screen flex flex-col" data-testid="site-layout">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <ScrollToTopButton />
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}
